export default __webpack_public_path__ + "static/media/edit-domain.258956c4.png";